// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"61332c3b","404":"5f52e0d8","498":"8bef3ec0"}[chunkId] + ".chunk.js";
};